import React, { useState } from 'react'

import Checkbox from '../../../../components/Checkbox/Checkbox'
import { Form } from '../../../../components/Form/Form'
import Select from '../../../../components/Select/Select'
import SelectItem from '../../../../components/Select/SelectItem'
import TextField from '../../../../components/TextField/TextField'
import t from '../../../../helpers/i18n'

const numberValidation = (text) =>
  /^[1-9][0-9]*$/.test(text) ? false : t('validations.number_is_invalid')

const NewCompetitionStepThree = ({ data, setFormValid }) => {
  const [gameplay, setGameplay] = useState()
  const [penaltyKicks, setPenaltyKicks] = useState()
  const [penaltyKicksRule, setPenaltyKicksRule] = useState()
  const [yellowCardAccumulation, setYellowCardAccumulation] = useState()
  const [toleranceReduction, setToleranceReduction] = useState()
  const [toleranceCycles, setToleranceCycles] = useState()
  const [substitutionsLimit, setSubstitutionsLimit] = useState()
  const [foulsAccumulation, setFoulsAccumulation] = useState()
  const [foulsToleranceReduction, setFoulsToleranceReduction] = useState()
  const [foulsToleranceCycles, setFoulsToleranceCycles] = useState()
  const [periodTimeouts, setPeriodTimeouts] = useState()

  return (
    <div>
      <h3>{t('titles.New competition - Global Gameplay Settings')}</h3>
      <Form data={data} onValidityChange={setFormValid}>
        <h4>{t('titles.Gameplay')}</h4>
        <Select
          label={t('labels.Gameplay')}
          onChange={(value) => setGameplay(value)}
          required
        >
          <SelectItem>- {t('select_item.Select_a_gameplay')} -</SelectItem>
          <SelectItem value='soccer'>{t('select_item.Soccer')}</SelectItem>
          <SelectItem value='football7'>{t('select_item.Football_7')}</SelectItem>
          <SelectItem value='minifootball'>{t('select_item.Mini_Football')}</SelectItem>
        </Select>

        <h4>{t('titles.Matches')}</h4>
        <Select name='rounds' label={t('labels.Rounds')} required>
          <SelectItem>- {t('select_item.Select_rounds')} -</SelectItem>
          <SelectItem value='one'>{t('select_item.One_round')}</SelectItem>
          <SelectItem value='two'>
            {t('select_item.Two_rounds_(home & away matches)')}
          </SelectItem>
        </Select>

        <h4>{t('titles.Duration')}</h4>
        {gameplay === 'minifootball' && (
          <Select name='periods_counts' label={t('labels.Number_of_periods')} required>
            <SelectItem>- {t('select_item.Select_the_number_of_periods')} -</SelectItem>
            <SelectItem value='2'>{t('select_item.%s periods', 2)}</SelectItem>
            <SelectItem value='4'>{t('select_item.%s periods', 4)}</SelectItem>
          </Select>
        )}

        <TextField
          name='period_duration'
          label={t('labels.Period_duration')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <TextField
          name='half_time_duration'
          label={t('labels.Half_time_duration')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <Checkbox
          name='enable_pause'
          label={t('for_check.Enable_Pause_timer_in_REF!')}
        />
        {gameplay === 'minifootball' && (
          <div>
            <Checkbox
              initiallyChecked={periodTimeouts}
              onChange={(checked) => setPeriodTimeouts(checked)}
              label={t('for_check.Enable "Period Timeouts" for teams in REF!')}
            />
            {periodTimeouts && (
              <TextField
                name='period_timeouts_amount'
                label={t('labels.Timeouts per team, per period')}
                maxLength={3}
                minLength={1}
                onValidation={numberValidation}
                required
              />
            )}
          </div>
        )}

        <h4>{t('titles.Points_per_result')}</h4>
        <TextField
          name='points_per_win'
          label={t('labels.Points_per_win')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <TextField
          name='points_per_draw'
          label={t('labels.Points_per_draw')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <TextField
          name='points_per_lost'
          label={t('labels.Points_per_lost')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />

        <h4>{t('titles.Forefit Matches')}</h4>
        <TextField
          name='forefit_points_for_winner'
          label={t('labels.Points_for_winner')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <TextField
          name='forefit_goals_for_winner'
          label={t('labels.Goals_for_winner')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <TextField
          name='forefit_points_taken_loser'
          label={t('labels.Points taken from loser')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />

        <h4>{t('titles.Penalty Kick Series')}</h4>
        <Checkbox
          initiallyChecked={penaltyKicks}
          onChange={(checked) => setPenaltyKicks(checked)}
          label={t('for_check.Penalty kick series')}
        />
        {penaltyKicks && (
          <div>
            <Select
              name='penalty_kicks_rule_1'
              label={t('labels.Rule %s', 1)}
              required={penaltyKicks}
            >
              <SelectItem>- {t('select_item.Select_a_rule')} -</SelectItem>
              <SelectItem value='all'>{t('select_item.At_all_matches')}</SelectItem>
              <SelectItem value='tie'>{t('select_item.Only_as_tie_breaker')}</SelectItem>
            </Select>
            <Select
              name='penalty_kicks_rule_2'
              label={t('labels.Rule %s', 2)}
              onChange={(value) => setPenaltyKicksRule(value)}
              required
            >
              <SelectItem>- {t('select_item.Select_a_rule')} -</SelectItem>
              <SelectItem value='series'>{t('select_item.Just_the_series')}</SelectItem>
              <SelectItem value='winner'>{t('select_item.Mandatory_winner')}</SelectItem>
            </Select>
            <TextField
              name='penalties_points_per_win'
              label={t('labels.Points_per_win')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            {penaltyKicksRule === 'series' && (
              <TextField
                name='penalties_points_per_draw'
                label={t('labels.Points_per_draw')}
                maxLength={3}
                minLength={1}
                onValidation={numberValidation}
                required
              />
            )}
            <TextField
              name='penalties_points_per_lost'
              label={t('labels.Points_per_lost')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
          </div>
        )}

        <h4>{t('titles.Referee_Body')}</h4>
        <Checkbox name='referee' label={t('for_check.Principal_referee')} />
        <Checkbox name='referee_assistant_1' label={t('for_check.Assitant_referee_%s', 1)} />
        <Checkbox name='referee_assistant_2' label={t('for_check.Assistant_referee %s', 2)} />
        <Checkbox name='referee_signals' label={t('for_check.Assistant_referee_signals')} />
        <Checkbox name='referee_timekeeper' label={t('for_check.Timekeeper_referee')} />
        <Checkbox name='referee_fourth_official' label={t('for_check.Fourth_official')} />
        <Checkbox name='referee_var_assistant' label={t('for_check.VAR assistant')} />

        <h4>{t('titles.Players_on_field')}</h4>
        <TextField
          name='starting_players'
          label={t('labels.Amount_of_starting_players')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />
        <TextField
          name='minimum_players'
          label={t('labels.Minimum_amount_of_players_on_the_field')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
          required
        />

        <h4>{t('titles.Players_on_bench')}</h4>
        <TextField
          name='bench_players_limit'
          label={t('labels.Limit_of_players_on_bench')}
          maxLength={3}
          minLength={1}
          onValidation={numberValidation}
        />

        {gameplay === 'minifootball' && (
          <div>
            <h4>{t('titles.Infraction_Cards_Settings')}</h4>
            <Checkbox
              name='use_blue_Card'
              label={t('for_check.Include_the_use_of_Blue_Card')}
            />
            <TextField
              name='red_card_timeout'
              label={t('labels.%s_red_card_timeout', 1)}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <TextField
              name='yellow_card_timeout'
              label={t('labels.%s_yellow_card_timeout', 1)}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <TextField
              name='blue_card_timeout'
              label={t('labels.%s_blue_card_timeout', 1)}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
          </div>
        )}

        {gameplay === 'minifootball' && (
          <div>
            <h4>{t('titles.Card_Accumulations')}</h4>
            <TextField
              name='yellow_cards_per_red_card'
              label={t('labels.Yellow_cards_for_1_red_card')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <TextField
              name='blue_cards_per_red_card'
              label={t('labels.Blue_cards_for_1_red_card')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <h5>{t('titles.Yellow_Cards_Blue_Cards_per_1_Red_Card')}</h5>
            <TextField
              name='combined_yellow_cards_per_red_card'
              label={t('labels.Yellow_cards')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <TextField
              name='combined_blue_cards_per_red_card'
              label={t('labels.Blue_cards')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
          </div>
        )}

        {gameplay !== 'minifootball' && (
          <div>
            <h4>{t('titles.Yellow_Card_Accumulation')}</h4>
            <Checkbox
              initiallyChecked={yellowCardAccumulation}
              onChange={(checked) => setYellowCardAccumulation(checked)}
              label={t('for_check.Set_yellow_card_accumulation')}
            />
            {yellowCardAccumulation && (
              <div>
                <TextField
                  name='yellow_cards'
                  label={t('labels.Number_of_yellow_Cards')}
                  maxLength={3}
                  minLength={1}
                  onValidation={numberValidation}
                  required
                />
                <TextField
                  name='suspended_matches'
                  label={t('labels.Number_of_matches_suspended')}
                  maxLength={3}
                  minLength={1}
                  onValidation={numberValidation}
                  required
                />
                <Select
                  name='suspensions_application'
                  label={t('labels.Suspensions_applies_to')}
                  required={yellowCardAccumulation}
                >
                  <SelectItem>- {t('select_item.Select_a_suspension_rule')} -</SelectItem>
                  <SelectItem value='groups'>{t('select_item.Group_phase')}</SelectItem>
                  <SelectItem value='playoffs'>{t('select_item.Playoffs_phase')}</SelectItem>
                  <SelectItem value='final'>{t('select_item.Final_phase')}</SelectItem>
                  <SelectItem value='all'>{t('select_item.All')}</SelectItem>
                </Select>

                <Checkbox
                  initiallyChecked={toleranceReduction}
                  onChange={(checked) => setToleranceReduction(checked)}
                  label={t('for_check.Tolerance_reduction_cycles')}
                />
                {toleranceReduction && (
                  <div>
                    <TextField
                      name='tolerance_cycles'
                      label={t('labels.Number_of_cycles')}
                      onChange={(value) => setToleranceCycles(value)}
                      maxLength={3}
                      minLength={1}
                      onValidation={numberValidation}
                    />
                    {toleranceCycles &&
                      Array(parseInt(toleranceCycles))
                        .fill(0)
                        .map((_, index) => (
                          <div key={index}>
                            <h5>
                              {t('titles.Cycle')} {index + 1}
                            </h5>
                            <TextField
                              name={'yellow_cards_' + index}
                              label={t('labels.Number_of_yellow_Cards')}
                              maxLength={3}
                              minLength={1}
                              onValidation={numberValidation}
                              required
                            />
                            <TextField
                              name={'suspended_matches_' + index}
                              label={t('labels.Number_of_matches_suspended')}
                              maxLength={3}
                              minLength={1}
                              onValidation={numberValidation}
                              required
                            />
                            <Select
                              name={'suspensions_application' + index}
                              label={t('labels.Suspensions_applies_to')}
                              required
                            >
                              <SelectItem>- {t('select_item.Select_a_suspension_rule')} -</SelectItem>
                              <SelectItem value='groups'>{t('select_item.Group_phase')}</SelectItem>
                              <SelectItem value='playoffs'>{t('select_item.Playoffs_phase')}</SelectItem>
                              <SelectItem value='final'>{t('select_item.Final_phase')}</SelectItem>
                              <SelectItem value='all'>{t('select_item.All')}</SelectItem>
                            </Select>
                          </div>
                        ))}
                  </div>
                )}

                <Checkbox
                  name='reset_accumulation_every_period'
                  label={t('for_check.Reset_count_every_period?')}
                />
              </div>
            )}
          </div>
        )}

        {(gameplay === 'football7' || gameplay === 'minifootball') && (
          <div>
            <h4>{t('titles.Fouls_Accumulation')}</h4>
            <Checkbox
              initiallyChecked={foulsAccumulation}
              onChange={(checked) => setFoulsAccumulation(checked)}
              label={t('for_check.Set_count_fouls_accumulation')}
            />
            {foulsAccumulation && (
              <div>
                <TextField
                  name='fouls_per_double_pk'
                  label={t('labels.Fouls for 1 "Double PK"')}
                  maxLength={3}
                  minLength={1}
                  onValidation={numberValidation}
                  required
                />

                <Checkbox
                  initiallyChecked={foulsToleranceReduction}
                  onChange={(checked) => setFoulsToleranceReduction(checked)}
                  label={t('for_check.Tolerance_reduction_cycles')}
                />
                {foulsToleranceReduction && (
                  <div>
                    <TextField
                      name='fouls_tolerance_cycles'
                      label={t('labels.Number_of_cycles')}
                      onChange={(value) => setFoulsToleranceCycles(value)}
                      maxLength={3}
                      minLength={1}
                      onValidation={numberValidation}
                    />
                    {foulsToleranceCycles &&
                      Array(parseInt(foulsToleranceCycles))
                        .fill(0)
                        .map((_, index) => (
                          <div key={index}>
                            <h5>
                              {t('titles.Cycle')} {index + 1}
                            </h5>
                            <TextField
                              name={'fouls_per_double_pk_' + index}
                              label={t('labels.Fouls for 1 "Double PK"')}
                              maxLength={3}
                              minLength={1}
                              onValidation={numberValidation}
                              required
                            />
                          </div>
                        ))}
                  </div>
                )}
                <Checkbox
                  name='reset_accumulation_every_period'
                  label={t('for_check.Reset_count_every_period?')}
                />
              </div>
            )}
          </div>
        )}

        <h4>{t('titles.Substitutions')}</h4>
        <Checkbox
          initiallyChecked={substitutionsLimit}
          onChange={(checked) => setSubstitutionsLimit(checked)}
          label={t('for_check.Set_a_substitutions_limit')}
        />
        {substitutionsLimit && (
          <div>
            <TextField
              name='substitutions_limit'
              label={t('labels.Substitutions limit')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <Checkbox
              name='substitutions_reentry'
              label={t('for_check.Allow_re-entry?')}
            />
          </div>
        )}
      </Form>
    </div>
  )
}

export default NewCompetitionStepThree
